import React from 'react';

export default (function () {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" },
    React.createElement(
      "circle",
      {
        cx: "50",
        cy: "50",
        r: "29.6",
        fill: "none",
        stroke: "#080808",
        strokeWidth: "7" },
      React.createElement("animate", {
        attributeName: "r",
        begin: "-0.5s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0 0.2 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "0;40"
      }),
      React.createElement("animate", {
        attributeName: "opacity",
        begin: "-0.5s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0.2 0 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "1;0"
      })
    ),
    React.createElement(
      "circle",
      {
        cx: "50",
        cy: "50",
        r: "8.3",
        fill: "none",
        stroke: "#080808",
        strokeWidth: "7" },
      React.createElement("animate", {
        attributeName: "r",
        begin: "0s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0 0.2 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "0;40"
      }),
      React.createElement("animate", {
        attributeName: "opacity",
        begin: "0s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0.2 0 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "1;0"
      })
    )
  );
});